import { Button, type ButtonProps } from "@mantine/core"
import { icons } from "../utils"

export function AdminButton({ children, ...props }: ButtonProps & { onClick?: () => void }) {
  return (
    <Button color="cyan" variant="subtle" size="compact-sm" leftSection={<icons.Star size={14} />} {...props}>
      {children}
    </Button>
  )
}
